<template>
  <div>
    <el-upload
      class="upload-demo"
      ref="upload"
      action="#"
      accept="image/jpeg,image/png,image/jpg"
      :list-type="listType"
      :http-request="UploadImage"
      :on-remove="handleRemove"
      :file-list="fileList"
      :limit="1"
    >
      <el-button size="small" type="primary" v-if="isShow" v-loading="loading">点击上传</el-button>
      <div slot="tip" class="el-upload__tip">tip：{{tipText}}，且上传成功过后，会有绿色成功标志哦！</div>
    </el-upload>
  </div>
</template>

<script>

export default {
  name: 'Test',
  props: {
    initUrl: {
      type: String,
      default: ''
    },
    actionUrl: {
      type: String,
      default: '/v1/picSave'
    },
    listType:{
      type:String,
      default:'picture'
    },
    tipText:{
      type:String,
      default:'只能上传一张图片'
    }
  },
  data() {
    return {
      loading : false,
      fileList: [],
      fileurl: '',// 接收返回的图片地址信息
      isShow:true
    };
  },
  created() {
    if (this.initUrl !== '' && this.initUrl !== null) {
      this.isShow=false;
      let obj = { url: '' };
      obj.url = this.initUrl;
      this.fileList[0] = obj;
    }
  },
  methods: {
    // 此处配合:before-upload="onBeforeUploadImage"属性 实现文件上传限制
    onBeforeUploadImage(file) {
      // const isIMAGE = file.type === 'image/jpeg' || 'image/jpg' || 'image/png';
      // const isLt1M = file.size / 1024 / 1024 < 1;
      // if (!isIMAGE) {
      //   this.$message.error('上传文件只能是图片格式!');
      // }
      // if (!isLt1M) {
      //   this.$message.error('上传文件大小不能超过 1MB!');
      // }
      // return isIMAGE && isLt1M;
    },
    async UploadImage(param) {
      const formData = new FormData();
      formData.append('file', param.file);
      const { data: res } = await this.$http.post(this.actionUrl, formData);
      if (res.status !== 0) {
        this.$message.error('上传失败！');
        param.onError();
      } else {
        this.fileurl = res.data.url;
        this.$message.success('上传成功！');
        this.isShow=false;  // 隐藏上传按钮
        param.onSuccess(); // 上传成功的图片会显示绿色的对勾
        this.$emit('change', this.fileurl);   // 触发父组件change事件
      }
      this.loading=false;
    },
    // 配合on-change事件使用
    // fileChange(file) {
    //   this.$refs.upload.clearFiles(); //清除文件对象
    //   this.logo = file.raw; // 取出上传文件的对象，在其它地方也可以使用
    //   this.fileList = [{ name: file.name, url: file.url }]; // 重新手动赋值filstList， 免得自定义上传成功了, 而fileList并没有动态改变， 这样每次都是上传一个对象

    // },
    handleRemove() {
      this.$message.success('移除成功！');
      // 触发清空操作
      this.fileList = [];
      this.fileurl = '';
      this.isShow=true;
      this.$emit('change', this.fileurl);
    }
  }
};
</script>

<style scoped>
</style>

